export default function removeEmojis(value) {
  const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g

  if (emojiRegex.test(value)) {
    const filteredInput = value.replace(emojiRegex, ' ')

    if (filteredInput.trim().length) return filteredInput.trim()
    else return null
  }

  return value
}
